/**
 * Curated UI fonts (self-hosted under `public/fonts/theme/`).
 * Keep in sync with `fsm-server/src/common/business-unit-theme-fonts.ts`.
 */
const FALLBACK_SANS =
  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const THEME_FONT_IDS = [
  'outfit',
  'inter',
  'dm-sans',
  'noto-sans',
  'space-grotesk',
  'roboto-condensed',
  'barlow',
  'ibm-plex-mono',
] as const;

export type ThemeFontId = (typeof THEME_FONT_IDS)[number];

export const DEFAULT_THEME_FONT_ID: ThemeFontId = 'space-grotesk';

/** CSS font-family stack (first faces must match @font-face in `themeFonts.css`). */
const PRIMARY_STACK: Record<ThemeFontId, string> = {
  outfit: `"Outfit Variable", "Outfit"`,
  inter: `"Inter Variable", "Inter"`,
  'dm-sans': `"DM Sans Variable", "DM Sans"`,
  'noto-sans': `"Noto Sans Variable", "Noto Sans"`,
  'space-grotesk': `"Space Grotesk Variable", "Space Grotesk"`,
  'roboto-condensed': `"Roboto Condensed Variable", "Roboto Condensed"`,
  barlow: `"Barlow"`,
  'ibm-plex-mono': `"IBM Plex Mono"`,
};

export const THEME_FONT_OPTIONS: { id: ThemeFontId; label: string }[] = [
  { id: 'outfit', label: 'Outfit' },
  { id: 'inter', label: 'Inter' },
  { id: 'dm-sans', label: 'DM Sans' },
  { id: 'noto-sans', label: 'Noto Sans' },
  { id: 'space-grotesk', label: 'Space Grotesk' },
  { id: 'roboto-condensed', label: 'Roboto Condensed' },
  { id: 'barlow', label: 'Barlow' },
  { id: 'ibm-plex-mono', label: 'IBM Plex Mono' },
];

export function themeFontFamilyCss(id: ThemeFontId): string {
  return `${PRIMARY_STACK[id]}, ${FALLBACK_SANS}`;
}

export function resolveThemeFontId(raw: string | null | undefined): ThemeFontId {
  if (raw && (THEME_FONT_IDS as readonly string[]).includes(raw)) {
    return raw as ThemeFontId;
  }
  return DEFAULT_THEME_FONT_ID;
}
